import { Modal, ModalContent } from '@nextui-org/react';
import { useTranslation } from 'react-i18next';
import { Check, Download, EllipsisVertical, Share, SquarePlus } from 'lucide-react';

const STEP_ICONS = { ios: [Share, SquarePlus, Check], android: [EllipsisVertical, Download, Check] };

/**
 * The way to install without the browser's prompt: the iPhone's (it has none), or Android's while Chrome's prompt isn't
 * in yet (the browser's menu › "Instalar app"; "Instalar agora" once it is). Three steps, each with the glyph the person
 * will look for on the screen. However it closes, it counts as an answer: a phone never says it installed.
 */
export const InstallSheet = ({ open, look = 'ios', onInstallNow = null, onClose }) => {
  const { t } = useTranslation();
  const copy = (key) => t(`components.InstallApp.${key}`);
  const icons = STEP_ICONS[look];

  return (
    <Modal
      isOpen={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      placement="auto"
      hideCloseButton
      aria-label={copy('sheetTitle')}
      classNames={{ base: 'mt-root mt-dialog mt-install-sheet', backdrop: 'mt-dialog__backdrop' }}
    >
      <ModalContent>
        {() => (
          <div className="mt-dialog__body mt-install-sheet__body">
            <h2 className="mt-dialog__title">{copy('sheetTitle')}</h2>
            <p className="mt-dialog__text">{copy('sheetLead')}</p>
            <ol className="mt-install-steps" data-look={look}>
              {icons.map((Icon, index) => (
                <li key={index} className="mt-install-steps__item">
                  <span className="mt-install-steps__n" aria-hidden="true">
                    {index + 1}
                  </span>
                  <span className="mt-install-steps__text">
                    <span className="mt-install-steps__title">{copy(`${look}Step${index + 1}Title`)}</span>
                    <span className="mt-install-steps__detail">{copy(`${look}Step${index + 1}Detail`)}</span>
                  </span>
                  <Icon className="mt-install-steps__icon" aria-hidden="true" />
                </li>
              ))}
            </ol>
            <div className="mt-install-sheet__actions">
              {onInstallNow && (
                <button type="button" className="mt-btn mt-btn--primary" onClick={onInstallNow}>
                  {copy('installNow')}
                </button>
              )}
              <button type="button" className="mt-btn mt-btn--quiet" onClick={onClose}>
                {copy('done')}
              </button>
            </div>
          </div>
        )}
      </ModalContent>
    </Modal>
  );
};
